import { useMemo } from "react";
import { newClientKey } from "../../../api/threads/threadsApi";
import { useWorkspace } from "../../../shell/workspace";
import { preparationPath } from "./intentAddress";
import type { PrepareOptions, ThreadIntent, ThreadPreparation } from "./threadIntent";

/**
 * `threads.prepare(intent)` (WA-11): the one way a feature starts work. It opens the Thread
 * view in preparation through the workspace (WA-10) and does nothing else: no model call, no
 * Thread on the server. Work that has a context to keep in view (`returnTo`) opens beside it,
 * in the neighbouring tab group, so the document or item stays visible (F31, F90). Work
 * started from the Threads section itself opens in place.
 */
export function useThreadPreparation(): ThreadPreparation {
  const workspace = useWorkspace();
  return useMemo(
    () => ({
      prepare: (intent: ThreadIntent, options?: PrepareOptions) => {
        workspace.open(preparationPath({ intent, requestKey: newClientKey() }), { placement: intent.returnTo === null ? "active" : "beside", replace: options?.inPlace === true });
      },
    }),
    [workspace],
  );
}
